/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var bodybuilder = require('bodybuilder');
var Ladda = require('ladda');
var moment = require('moment');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');

var StringCell = require('common/backgrid/StringCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');
var MomentCell = require('common/backgrid/MomentCell');
// var BooleanCell = require('common/backgrid/BooleanCell');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');
var SearchCOCEvents = require('../services/SearchCOCEvents');
var COCInternalSidebarNavView = require('../views/COCInternalSidebarNavView');

require('../styles/COCEventSearchView.css');
var tmplCOCEventSearchView = require('../templates/COCEventSearchView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventSearchView,

  className: 'coc-event-search-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    newEvent: '.btn-new-Event',
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    clearFilters: '.clear-filters',
    formInputs: ':input',
    eventDateStart: '.date-event-from',
    eventDateEnd: '.date-event-to'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'click @ui.clearFilters': 'onClickClearFilters',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  templateHelpers: function() {},

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());

    this.ui.eventDateStart.datepicker();
    this.ui.eventDateEnd.datepicker();

    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'eventTitle',
          label: 'Event Title',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'eventType',
          label: 'Event Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'venueName',
          label: 'Venue Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'venueStreetAddress',
          label: 'Venue Address',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'venueCounty',
          label: 'Venue County',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'organizationName',
          label: 'Organization Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'presenters',
          label: 'Presenter(s)',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'program1',
          label: 'Program',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'eventDate',
          label: 'Event Start Date',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateFormatter.extend({
            emptyValue: '--'
          }),
          sortValue: MomentCell.MomentSortValue,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'isThirdPartyEvent',
          label: 'AARP Event?',
          cell: StringCell,
          headerCell: 'custom',
          width: 5,
          editable: false
        },
        {
          name: '',
          label: '',
          cell: ButtonLinkCell.extend({
            name: 'Open',
            newTab: true,
            buttonClass: 'btn-primary btn-sm',
            href: function(model) {
              return '#coc/event/' + model.get('eventId');
            }
          }),
          headerCell: 'custom',
          width: 5,
          sortable: false,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 50 }),
      emptyText: 'No Events Found'
    });

    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });
    // If no inputs were given, do not perform a search.
    if (
      !data.eventTitle &&
      !data.eventTypeId &&
      !data.venueName &&
      !data.venueAddress &&
      !data.venueCounty &&
      !data.organizationName &&
      !data.presenter &&
      !data.program1Id &&
      !data.eventDateStart &&
      !data.eventDateEnd &&
      !data.isAARPEvent
    ) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.eventTitle) {
      body.query('bool', function(b) {
        b.orQuery('match', 'eventTitle', {
          query: data.eventTitle,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'eventTitle', data.eventTitle.toLowerCase() + '*');
        b.orQuery('match', 'eventTitle.phonetic', data.eventTitle);
        return b;
      });
    }

    if (data.eventTypeId) {
      body.query('match', 'eventTypeId', data.eventTypeId);
    }

    if (data.venueName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'venueName', {
          query: data.venueName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'venueName', data.venueName.toLowerCase() + '*');
        b.orQuery('match', 'venueName.phonetic', data.venueName);
        return b;
      });
    }

    if (data.venueAddress) {
      body.query('bool', function(b) {
        b.orQuery('match', 'venueStreetAddress', {
          query: data.venueAddress,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'venueStreetAddress', data.venueAddress.toLowerCase() + '*');
        b.orQuery('match', 'venueStreetAddress.phonetic', data.venueAddress);
        return b;
      });
    }

    if (data.venueCounty) {
      body.query('wildcard', 'venueCounty', data.venueCounty.toLowerCase() + '*');
    }

    if (data.organizationName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'organizationName', {
          query: data.organizationName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'organizationName', data.organizationName.toLowerCase() + '*');
        b.orQuery('match', 'organizationName.phonetic', data.organizationName);
        return b;
      });
    }

    if (data.presenter) {
      body.query('bool', function(b) {
        b.orQuery('match', 'presenters', {
          query: data.presenter,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'presenters', data.presenter.toLowerCase() + '*');
        b.orQuery('match', 'presenters.phonetic', data.presenter);
        return b;
      });
    }

    if (data.program1Id) {
      body.query('match', 'program1Id', data.program1Id);
    }

    if (data.isAARPEvent) {
      body.query('match', 'isThirdPartyEvent', data.isAARPEvent);
    }

    var eventDateStart = moment(data.eventDateStart, 'MM/DD/YYYY'),
      eventDateEnd = moment(data.eventDateEnd, 'MM/DD/YYYY');

    if (data.eventDateStart && data.eventDateEnd) {
      body.query('bool', function(b) {
        b.andQuery('range', 'eventStartDateTime', {
          gte: eventDateStart.format('YYYY-MM-DD')
        });
        b.andQuery('range', 'eventStartDateTime', {
          lte: eventDateEnd.format('YYYY-MM-DD')
        });
        return b;
      });
    } else {
      if (data.eventDateStart) {
        body.query('range', 'eventStartDateTime', {
          gte: eventDateStart.format('YYYY-MM-DD')
        });
      }
      if (data.eventDateEnd) {
        body.query('range', 'eventStartDateTime', {
          lte: eventDateEnd.format('YYYY-MM-DD')
        });
      }
    }

    body.size(this.model.get('searchLimit'));
    var bodyObj = body.build();

    SearchCOCEvents(bodyObj)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickClearFilters: function() {
    this.ui.formInputs.val('');
  }
});
